import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Modal, Typography, Button, MenuItem } from '@material-ui/core';

import themeColors from '../../assets/colors';

const useStyles = makeStyles(() => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    container: {
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: themeColors.background.default,
        padding: 20,
        width: '70%',
        maxHeight: '70%',
        borderRadius: 10,
    },
    bottom: {
        display: 'flex',
        alignSelf: 'flex-end',
        marginTop: 20
    }
}));

const Avoided = ({ open, onClose, data, workday = false }) => {

    const classes = useStyles();

    return (
        <Modal
            open={open}
            onClose={onClose}
            className={classes.root}
        >
            <div className={classes.container}>
                {
                    workday ?
                        <>
                            <Typography variant='h2'>{'Workday request error'}</Typography>

                            <Typography variant='subtitle1'>{data?.message}</Typography>

                            <div style={{ overflow: 'auto' }}>
                                {Object.keys(data).map((key, i) => (
                                    <React.Fragment key={i}>
                                        {
                                            (key !== 'message' && data[key]?.length) ?
                                                <>
                                                    <Typography variant='subtitle1'>{`${key} (${data[key]?.length})`}</Typography>
                                                    {data[key]?.map((item, j) => <MenuItem key={`${i}${j}`}>{item}</MenuItem>)}
                                                </>
                                                :
                                                <></>
                                        }
                                    </React.Fragment>
                                ))}
                            </div>
                        </>
                        :
                        <>
                            <Typography variant='h2'>{'Avoided employees code'}</Typography>
                            <Typography variant='subtitle1'>{'The codes below do not exist in the system'}</Typography>

                            <div style={{ overflow: 'auto' }}>
                                {
                                    data?.map(item => <MenuItem key={item}>{item}</MenuItem>)
                                }
                            </div>
                        </>
                }
                <div className={classes.bottom}>
                    <Button
                        variant='contained'
                        color='secondary'
                        onClick={onClose}
                    >
                        {'Close'}
                    </Button>
                </div>
            </div>
        </Modal>
    );
}

export default Avoided;